import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DateFormatPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-cyclical-call-fault-cell',
  templateUrl: './cyclical-call-fault-cell.component.html',
  imports: [FlexLayoutModule, TranslatePipe, MatTooltip, DateFormatPipe, MatIcon],
  providers: [DateFormatPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cyclical-call-fault-cell.component.scss']
})
export class CyclicalCallFaultCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<ICellRendererParams> = signal(null);

  agInit(params: ICellRendererParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
